import script from "./TransferPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransferPage.vue?vue&type=script&lang=ts&setup=true"

import "./TransferPage.vue?vue&type=style&index=0&id=3c952250&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c952250"]])

export default __exports__